import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import { useAnimatedModal } from '@perpay-web/components/base/Modal/useAnimatedModal';
import { useModal } from '@perpay-web/components/base/Modal/useModal';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import GetACallFromUsModal from '@perpay-web/fintech/components/screens/IdentityVerificationRequired/GetACallFromUsModal';
import { generatePhoneTemplateHref } from '@perpay-web/fintech/utils/routeUtils';

import { CTA_DISPLAY_PHONE_NUMBER, CTA_PHONE_NUMBER } from './CtaPhoneNumber';
import styles from './IdentityVerificationRequired.scss';
import IdentityVerificationTemplate from './IdentityVerificationTemplate';

const IdentityVerificationExtended = () => {
    const { isModalOpen, setIsModalOpen } = useModal();
    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useAnimatedModal({ isModalOpen, setIsModalOpen });

    const copyContent = (
        <>
            <p className={styles.copy}>
                It looks like you&apos;ve put an alert on your credit file.
                It&apos;s great that you&apos;re taking steps to protect
                yourself from fraud, but because of this alert, we need to get
                in touch with you before we can proceed with your application.
            </p>
            <p className={styles.copy}>
                <b>What You Need to Do:</b>
            </p>
            <p className={styles.copy}>
                You can call us directly at {CTA_DISPLAY_PHONE_NUMBER} or expect
                a call from us within the next business day.
            </p>
            <p className={styles.copy}>
                <b>Timeframe:</b>
            </p>
            <p className={styles.copy}>
                We will close your application if we are not able to verify your
                identity within the next 30 days.
            </p>
        </>
    );

    const footerContent = (
        <>
            <CardCta
                action='primary'
                Component={CustomLink}
                className={styles['footer-button']}
                href={generatePhoneTemplateHref(CTA_PHONE_NUMBER)}
            >
                Call us
            </CardCta>
            <CustomButton
                action='inline-link'
                onClick={() => setIsAnimatedModalOpen(true)}
            >
                Get a call from us
            </CustomButton>
        </>
    );

    return (
        <>
            <IdentityVerificationTemplate
                copyContent={copyContent}
                footerContent={footerContent}
            />
            {isAnimatedModalOpen ? (
                <GetACallFromUsModal
                    className={animatedModalClassName}
                    onClose={() => setIsAnimatedModalOpen(false)}
                />
            ) : null}
        </>
    );
};

export default IdentityVerificationExtended;
